export const INIT = '[INIT]'
export const INIT_GAME = `${INIT} Set Initial values for the game`

export const initialiseGame = () => ({
    type: INIT_GAME,
    payload: {},
    meta: {
        persisted: 'gameInitialised',
        initGameAction: true,
    },
})
